var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var dataFilter = function (actionItems, requiredItems) {
    var _a, _b;
    return (actionItems &&
        ((_b = (_a = __spreadArray([], Object.keys(actionItems), true)) === null || _a === void 0 ? void 0 : _a.filter(function (key) { return requiredItems.includes(key); })) === null || _b === void 0 ? void 0 : _b.reduce(function (obj, key) {
            obj[key] = actionItems[key];
            return obj;
        }, {})));
};
